/**
 * SafeChlor Custom Header JS
 * Handles: Mobile drawer, Search panel, Dropdowns, Sub-menu accordion
 */
(function () {
  'use strict';

  const mobileToggle     = document.getElementById('mobile-menu-toggle');
  const mobileClose      = document.getElementById('mobile-menu-close');
  const mobileDrawer     = document.getElementById('mobile-menu-drawer');
  const mobileOverlay    = document.getElementById('mobile-menu-overlay');
  const searchToggle     = document.getElementById('search-toggle');
  const searchClose      = document.getElementById('search-close');
  const searchPanel      = document.getElementById('search-panel');
  const searchInput      = document.getElementById('header-search-input');
  const header           = document.getElementById('custom-header');
  const dropdownToggles  = document.querySelectorAll('.custom-header__nav-link--dropdown');
  const mobileAccordions = document.querySelectorAll('.mobile-menu-drawer__link--toggle');

  // ── Mobile Drawer ──────────────────────────────────────────
  function openMobileMenu() {
    mobileDrawer.setAttribute('aria-hidden', 'false');
    mobileOverlay.setAttribute('aria-hidden', 'false');
    mobileToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(() => { const f = mobileDrawer.querySelector('a, button'); if (f) f.focus(); }, 250);
  }

  function closeMobileMenu() {
    mobileDrawer.setAttribute('aria-hidden', 'true');
    mobileOverlay.setAttribute('aria-hidden', 'true');
    mobileToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (mobileToggle) mobileToggle.focus();
  }

  if (mobileToggle)  mobileToggle.addEventListener('click', openMobileMenu);
  if (mobileClose)   mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // ── Mobile Accordion ───────────────────────────────────────
  mobileAccordions.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      const sub = toggle.nextElementSibling;
      mobileAccordions.forEach(function (t) {
        if (t !== toggle) {
          t.setAttribute('aria-expanded', 'false');
          const s = t.nextElementSibling;
          if (s) s.setAttribute('aria-hidden', 'true');
        }
      });
      toggle.setAttribute('aria-expanded', String(!expanded));
      if (sub) sub.setAttribute('aria-hidden', String(expanded));
    });
  });

  // ── Desktop Dropdowns ──────────────────────────────────────
  dropdownToggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      dropdownToggles.forEach(b => b.setAttribute('aria-expanded', 'false'));
      btn.setAttribute('aria-expanded', String(!expanded));
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.custom-header__nav-item--dropdown')) {
      dropdownToggles.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    }
  });

  // ── Search Panel ───────────────────────────────────────────
  function openSearch() {
    searchPanel.setAttribute('aria-hidden', 'false');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
    setTimeout(() => { if (searchInput) searchInput.focus(); }, 200);
  }
  function closeSearch() {
    searchPanel.setAttribute('aria-hidden', 'true');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    if (searchToggle) searchToggle.focus();
  }
  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose)  searchClose.addEventListener('click', closeSearch);

  // ── Escape Key ─────────────────────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (mobileDrawer && mobileDrawer.getAttribute('aria-hidden') === 'false') closeMobileMenu();
    if (searchPanel  && searchPanel.getAttribute('aria-hidden')  === 'false') closeSearch();
  });

  // ── Scroll Shadow ──────────────────────────────────────────
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 10
        ? '0 4px 20px rgba(0,0,0,0.18)'
        : '0 2px 12px rgba(0,0,0,0.12)';
    }, { passive: true });
  }

})();